import React from 'react';
import { WidgetWrapper } from 'utils/widget';
import { pageForbiddenStrategyWizard } from 'containers/403/styles';

const { unknownErrorContent, unknownErrorLink } = pageForbiddenStrategyWizard;

export const PageUnknownErrorMessage = () => <p style={unknownErrorContent}>Media Optimizations is unable to load this strategy. Please open a support ticket for further investigation.</p>;

export const PageUnknownErrorFooter = () => <a href="#" style={unknownErrorLink} onClick={() => WidgetWrapper('open')}>Contact Support</a>;
